// @@FORM_SPAM_v96@@ Human labels for spam-guard reason codes (server/lib/spam-guard.js LABELS).
const LABELS = {
  replayed: 'Form token already used', expired: 'Form was open more than 2 days', legacy_token: 'Old form (before the spam filter)',
  no_user_agent: 'No browser identification', bot_user_agent: 'Sent by a script, not a browser', no_accept_language: 'Browser language missing',
  cross_site: 'Posted from another website', one_link: 'Contains a link', links: 'Contains 2 links', many_links: 'Contains 3+ links',
  link_markup: 'HTML/BBCode link markup', foreign_script: 'Mostly non-Latin text', gibberish_name: 'Random-letter name',
  gibberish_company: 'Random-letter company', url_in_name: 'Link or email in the name', same_fields: 'Same text in several fields',
  disposable_email: 'Throwaway email domain', dotted_email: 'Dotted-up email trick', short_message: 'Very short message',
  duplicate_message: 'Same message from a different sender', resubmitted: 'Same message sent again', repeat_sender: '3+ submissions in 24 hours',
  marked_by_hand: 'Marked as spam in HQ',
};
export function reasonLabel(code) {
  const c = String(code || '');
  if (c.startsWith('phrase:')) return `Sales-pitch phrase “${c.slice(7)}”`;
  return LABELS[c] || c;
}
// Pitch phrases are grouped: Sales-pitch phrases “seo”, “first page of google”.
export function reasonList(codes) {
  const list = codes || [];
  const phrases = list.filter((c) => String(c).startsWith('phrase:')).map((c) => `“${String(c).slice(7)}”`);
  const rest = list.filter((c) => !String(c).startsWith('phrase:')).map(reasonLabel);
  if (phrases.length) rest.push((phrases.length === 1 ? 'Sales-pitch phrase ' : 'Sales-pitch phrases ') + phrases.join(', '));
  return rest.join(' · ');
}
export const SPAM_PILL = {
  display: 'inline-block', padding: '3px 10px', borderRadius: 999, fontSize: 11, fontWeight: 600, letterSpacing: '.04em',
  textTransform: 'uppercase', background: 'rgba(255,122,115,.12)', color: '#ff8c86', border: '1px solid rgba(255,122,115,.25)', whiteSpace: 'nowrap',
};
